import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana73Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
  <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  <rect width="1221" height="921" fill="url(#pattern0_1465_19734)"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("14"))}
    d="M368.117 526.358V501.393H293.224L270.75 553.821C268.753 581.783 289.891 580.451 300.709 576.29L368.117 526.358Z" 
    fill={getFillByLot(14, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("15"))}
    d="M368.126 419.012V501.399H293.228L325.684 419.012H368.126Z" 
    fill={getFillByLot(15, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}
    d="M510.43 416.508L368.125 523.861V419.004L510.43 416.508Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("3"))}
    d="M355.634 346.607L325.675 419.008H448.008V346.607H355.634Z" 
    fill={getFillByLot(3, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("2"))}
    d="M557.866 346.607H448.016V419.008H507.934L570.349 369.077C576.34 355.096 564.523 348.272 557.866 346.607Z" 
    fill={getFillByLot(2, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <defs>
      <pattern id="pattern0_1465_19734" patternContentUnits="objectBoundingBox" width="1" height="1">
      <use href="#image0_1465_19734" transform="matrix(0.00342448 0 0 0.00453994 -5.73038 -4.59616)"/>
      </pattern>
      <image id="image0_1465_19734" width="4096" height="2304" href="/mz2.png"/>
    </defs>
</svg>

  );
};
